import styled from 'styled-components';

export const headerHeight = {
  desktop: '5.25rem',
  mobile: '5rem',
};

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100%;
  height: ${headerHeight.mobile};
  padding: 0 18px;
  background-color: ${Styles.color.black};

  ${Styles.desktop`
    height: ${headerHeight.desktop};
    padding: 0 20px;
  `}
`;

export const HeaderText = styled.h1`
  margin: 8px 0 5px;
  color: ${Styles.color.white};
  font-family: ${Styles.fontFamily.base};
  text-transform: ${Styles.textTransform.headlines};
  letter-spacing: -0.53px;
  line-height: 1.375rem;
  font-size: 2rem;
  font-weight: normal;
  ${Styles.desktop`
    font-size: 2.25rem;
  `}
`;
